import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { UserBarGroup, UserBarGroupLinkWrap } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { appTranslationKeys } from '../translations';

const StyledUserBarGroupLinkWrap = styled(UserBarGroupLinkWrap)`
   color: ${(props) => props.theme.secondaryDark};
`;
StyledUserBarGroupLinkWrap.displayName = 'StyledUserBarGroupLinkWrap';

export const ExperimentalMonitUserBarGroup = (): JSX.Element | null => {
   // This one is expected
   // eslint-disable-next-line @dreryk/check-experimental-to-do
   return protectFeature(
      'experimental',
      <UserBarGroup testId={'experimentalMonit'}>
         <StyledUserBarGroupLinkWrap testId={'experimentalMonit'}>
            <Translate>{appTranslationKeys.experimental}</Translate>
         </StyledUserBarGroupLinkWrap>
      </UserBarGroup>,
      null
   );
};
